import { configuredFetchBaseQuery } from '@config/rtkQuery';
import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/dist/query/react';

export const ticketApi = createApi({
  reducerPath: 'ticketApi',
  baseQuery: configuredFetchBaseQuery(),
  endpoints: (builder) => ({
    getOpen: builder.query({
      query: () => ({ url: 'customer/tickets/open' }),
      transformResponse: (response) => response.results,
      transformErrorResponse: (response) => {
        response.data = response.data?.message;
        return response;
      },
      providesTags: ['OpenTickets'],
    }),
    getHistory: builder.query({
      query: () => ({ url: 'customer/tickets/history' }),
      transformResponse: (response) => response.results,
      transformErrorResponse: (response) => {
        response.data = response.data?.message;
        return response;
      },
      providesTags: ['TicketsHistory'],
    }),
    getDetails: builder.query({
      query: (arg) => {
        const { ticketID } = arg;
        return { url: `customer/tickets/${ticketID}/details` };
      },
      providesTags: (result, error, { ticketID }) => [
        { type: 'TicketDetails', ticketID },
      ],
    }),
    getTicketCountries: builder.query({
      query: () => ({ url: `customer/tickets/countries-for-select` }),
      transformErrorResponse: (response) => {
        response.data = response.data?.message;
        return response;
      },
    }),
    getTicketTypes: builder.query({
      query: () => ({ url: `customer/tickets/ticket-types-for-select` }),
    }),
    createTicket: builder.mutation({
      query(arg) {
        const { data } = arg;
        const bodyFormData = new FormData();
        Object.entries(data).forEach(([key, value]) => {
          if (key === 'attachments') {
            for (let i = 0; i < value.length; i += 1) {
              bodyFormData.append(key, value[i]);
            }
            return;
          }
          bodyFormData.append(key, value);
        });
        return {
          url: `customer/tickets/create`,
          method: 'POST',
          body: bodyFormData,
          formData: true,
        };
      },
      transformResponse: (response) => response.message,
      invalidatesTags: ['OpenTickets', 'TicketsHistory'],
    }),
    postComment: builder.mutation({
      query(arg) {
        const { ticketID, data } = arg;
        const bodyFormData = new FormData();
        Object.entries(data).forEach(([key, value]) => {
          if (key === 'attachments') {
            for (let i = 0; i < value.length; i += 1) {
              bodyFormData.append(key, value[i]);
            }
            return;
          }
          bodyFormData.append(key, value);
        });
        return {
          url: `customer/tickets/${ticketID}/post-comment`,
          method: 'POST',
          body: bodyFormData,
          formData: true,
        };
      },
      transformResponse: (response) => response.message,
      invalidatesTags: (result, error, { ticketID }) => [
        { type: 'TicketDetails', ticketID },
      ],
    }),
  }),
});

const initialState = {
  open: { isLoading: false, data: [] },
  closed: { isLoading: false, data: [] },
  details: { isLoading: false, data: {} },
};

const ticketsSlice = createSlice({
  name: 'tickets',
  initialState,
  extraReducers: (builder) => builder,
});

export default ticketsSlice.reducer;
